"use client";

import React, { forwardRef } from "react";
import * as Primitive from "@radix-ui/react-tabs";
import { cn } from "../../lib/cn";

export const Tabs = Primitive.Root;

export const TabsList = forwardRef<
  React.ElementRef<typeof Primitive.List>,
  React.ComponentPropsWithoutRef<typeof Primitive.List>
>(({ className = "", ...props }, ref) => (
  <Primitive.List
    ref={ref}
    className={cn("inline-flex items-center gap-1 rounded-sm bg-surface p-1", className)}
    {...props}
  />
));
TabsList.displayName = "TabsList";

export const TabsTrigger = forwardRef<
  React.ElementRef<typeof Primitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof Primitive.Trigger>
>(({ className = "", ...props }, ref) => (
  <Primitive.Trigger
    ref={ref}
    className={cn(
      "rounded-sm px-3 py-1.5 text-sm font-medium text-text-muted transition-colors",
      "data-[state=active]:bg-surface-raised data-[state=active]:text-text data-[state=active]:shadow-sm",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-600/40",
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = "TabsTrigger";

export const TabsContent = forwardRef<
  React.ElementRef<typeof Primitive.Content>,
  React.ComponentPropsWithoutRef<typeof Primitive.Content>
>(({ className = "", ...props }, ref) => (
  <Primitive.Content ref={ref} className={cn("mt-4 focus:outline-none", className)} {...props} />
));
TabsContent.displayName = "TabsContent";
